import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  const { type, appbar, getContrastText } = theme.palette;
  const backgrdButton = getContrastText(appbar[type]);
  const colorButton = getContrastText(backgrdButton);

  let checkValidColor = (color) => {
    if (["info", "warning", "success", "error", "primary", "secondary"].includes(color)) return color
    else return null
  }

  return {
    flex: {
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "center",
      alignItems: "center",
      marginLeft: 15
    },
    relative: {
      position: "relative"
    },
    button: {
      color: colorButton,
      background: p => checkValidColor(p.colorButtonOnProjectBar) || backgrdButton,
      textTransform: "none",
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.pxToRem(14),
      opacity: p => p.opened ? 0.2 : 0.6,
      cursor: p => p.opened ? "default" : "pointer",
      "&:focus": {
        opacity: 1
      },
      "&:hover": {
        color: colorButton,
        background: backgrdButton,
        opacity: 1,
      },
      // height: 30,
      paddingTop: 1,
      paddingBottom: 1,
      marginLeft: 5,
      marginRight: 5
    },
    icon: {
      position: "absolute",
      top: -6,
      right: -2,
      width: "auto !important",
      "& > *": {
        width: "auto !important"
      }
    },
    cancelIcon: {
      color: theme.palette.error.main
    }
  };
});
